import apiInstance from "./index";

/**
 * The signed-in user's own time zone (flex2-api TimezoneController). Both
 * calls need only a signed-in user: the list is the same IANA catalogue for
 * everyone, and saveMine sets the CALLER's profile, never anyone else's.
 */
export const TimezonesApiService = {
  // -> { data: { data: [ { id, name: "(UTC-05:00) America/New_York", timezone } ] } }
  list: () => apiInstance.get("/timezones"),

  // body: { timezone: "America/Chicago" } -> { data: { data: <own profile> } }
  saveMine: (timezone) => apiInstance.post("/timezones/user/add", { timezone }),
};

export default TimezonesApiService;
